import type { ButtonVariant } from 'components/Button/Button.types';
import {
  inspiredAnimation,
  likeAnimation,
  loveAnimation,
} from 'components/LottieAnimation/lottieAnimationsData';
import type { I18nFn } from 'i18n/types/I18nFn';
import type { CmsApiReactionType } from 'modules/cms/api/reactions/types/CmsApiReactionType';

export function REACTIONS(i18n: I18nFn) {
  return {
    LIKE: {
      animation: likeAnimation,
      text: i18n('Like'),
      buttonVariant: 'reaction-like' as ButtonVariant,
      qaId: 'like-button',
    },
    LOVE: {
      animation: loveAnimation,
      text: i18n('Love'),
      buttonVariant: 'reaction-love' as ButtonVariant,
      qaId: 'love-button',
    },
    INSPIRED: {
      animation: inspiredAnimation,
      text: i18n('Inspired'),
      buttonVariant: 'reaction-inspired' as ButtonVariant,
      qaId: 'inspired-button',
    },
  } as const satisfies Record<CmsApiReactionType, unknown>;
}
